import { configureStore } from '@reduxjs/toolkit';
import erpnextLoginSlice from './login/loginSlice';
import searchPatientDetailsByDocumentIdSlice from './searchPatientByMRN/searchPatientByDocumentIdSlice';
import toggleAppBarLoadingSlice from './appLoader/toggleAppBarLoadingSlice';
import tokenListSlice from './tokenList/tokenListSlice';
import addNewVisitSlice from './addNewVisit/addNewVisitSlice';
import rfIdListSlice from './rfIdList/rfIdListSlice';
import addReVisitSlice from './addReVisit/addReVisitSlice';
import getSchemeListSlice from './getSchemeList/getSchemeListSlice';
import addPatientDataDetailsSlice from './patientDataDetails/addPatientDataDetails/addPatientDataDetailsSlice';
import imageUploadReducer from './ImageUpload/imageUploadSlice';
import patientDataPointListByPatientIDSlice from './patientDataDetails/patientDataPointListByPatientID/patientDataPointListByPatientIDSlice';

const store = configureStore({
  reducer: {
    loginDetails: erpnextLoginSlice,
    tokenListRes: tokenListSlice,
    addVisitRes: addNewVisitSlice,
    rfIdListRes: rfIdListSlice,
    addReVisitRes: addReVisitSlice,
    searchPatientDetailsByDocumentIdRes: searchPatientDetailsByDocumentIdSlice,
    toggleAppBarLoadingSliceRes: toggleAppBarLoadingSlice,
    getSchemeListRes: getSchemeListSlice,
    addPointDataDetailsRes: addPatientDataDetailsSlice,
    // expose image upload slice so components can read/set document type and upload progress
    imageUploading: imageUploadReducer,
    getPatientDataDetailsRes: patientDataPointListByPatientIDSlice
  },
});

export default store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, alerts: AlertsState}
export type AppDispatch = typeof store.dispatch;
